/*
  The thin client only has basic functionality like getting the events and uuid's.
  This prevents having to include extra dependencies that are only needed for actual backend communication.
  This is used by the partner iframes.
 */

import { applyIdentityToUrl, sSessionStorage } from "@solvari/utils";

import type { ArgusEvent } from "@/service/backendSync.ts";

declare global {
  // oxlint-disable-next-line typescript/consistent-type-definitions
  interface SessionStorage {
    argusEvents: ArgusEvent[];
  }
}

function getArgusEvents() {
  return sSessionStorage.getItem("argusEvents");
}

function redirectWithTracking(link: string) {
  const url = applyIdentityToUrl(link);

  try {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.rel = "external";
    anchor.id = "tracking-redirect";
    document.body.append(anchor);
    anchor.click();
  } catch (_error) {
    window.location.href = url;
  }
}

export { getArgusEvents, redirectWithTracking };
